import React, { useState, useEffect } from "react";
import {
  useGetInterestedBuyersListQuery,
  useNegotiationTimelineMutation,
} from "features/Procurement/common/ProcurementApiSlice";

import {
  Popover,
  IconButton,
  Select,
  MenuItem,
  Button,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
  Box,
} from "@mui/material";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CancelIcon from "@mui/icons-material/Cancel";
import { toast } from "react-toastify";
import NegotiateWithSeller from "./NegotiateWithSellerModal";
import SkeletonLoader from "./SkeletonLoader";
import { Spinner } from "react-bootstrap";
export default function BuyerInterestedForSeller({
  BuyersActiveId,
  user_id,
  BuyersList,
  refetch,
  setNegotiationView,
  negotiationView,
  setInterestedBuyerModal,InterestedBuyerModal
}) {
  const { data: getBuyersList, isLoading,refetch:refetchBuyers } = useGetInterestedBuyersListQuery(
    BuyersActiveId,
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const [BuyersActiveList, setBuyersActiveList] = useState([]);
  // const [negotiationView, setNegotiationView] = useState(null);
  const [increaseTimeline] = useNegotiationTimelineMutation();
  const [anchorTimeline, setAnchorTimeline] = useState(null);
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedBuyer, setSelectedBuyer] = useState(null);
  const [negotiationItem, setNegotiationItem] = useState("");
  const [expanded, setExpanded] = useState("panel1");
  const [showFields, setShowFields] = useState(false);
  const [negotiatioanValues, setNegotiationValue] = useState({
        price: negotiationItem?.price,
        quantity: negotiationItem?.quantity,
        procurement: negotiationItem?.id,
        message: "",
        send_to: negotiationItem.created_by
      });
 const[timelineloader,settimelineloader]=useState(false)
       useEffect(()=>{
        refetchBuyers()
       },[InterestedBuyerModal])
  useEffect(() => {
    if (getBuyersList) {
      setBuyersActiveList(getBuyersList?.data);
    }
  }, [getBuyersList]);
  const handlePopoverCloseTimeline = () => setAnchorTimeline(null);
  const handlePopoverOpenTimeline = (event, buyer) => {
    setAnchorTimeline(event.currentTarget);
    setSelectedBuyer(buyer);
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleIncreaseTimeline = () => {
    const id = selectedBuyer.ProcCode;
    const payload = {
      valid_until: selectedDay === 1 ? "24" : selectedDay === 2 ? "48" : "72",
      trade_initiated:"Seller"
    };
    settimelineloader(true)
    increaseTimeline({ id: id, payload: payload })
      .unwrap()
      .then(async (data) => {
        toast.success("Timeline Updated!");
        handlePopoverCloseTimeline();
        setSelectedDay("");
        settimelineloader(false)
        refetchBuyers()
        await refetch();
      })
        .catch(() => {
              toast.error("Something went wrong! We will get back Soon!!");
              settimelineloader(false)
            } ) };

  const handleNegotiationView = (index, buyer) => {
    setNegotiationView(negotiationView === index ? null : index);
    setNegotiationItem(buyer);
    setNegotiationValue({
      price: negotiationItem?.price,
      quantity: negotiationItem?.quantity,
      procurement: negotiationItem?.id,
      message: "",
      send_to:negotiationItem.created_by
    });
  };

  return (
    <Grid container spacing={2}>
      {isLoading ? (
        <SkeletonLoader />
      ) : (
        <Grid item xs={12} md={negotiationView !== null ? 6 : 12}>
          {BuyersActiveList?.map((item, index) => {
            const panel = `panel${index + 1}`;
            const isExpanded = expanded === panel;
            return (
              <Accordion
                key={index}
                expanded={isExpanded}
                onChange={handleChange(panel)}
              >
                <AccordionSummary
                  aria-controls={`${panel}d-content`}
                  id={`${panel}d-header`}
                  className="accordionColor"
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                      <Typography variant="h6" className="text-blue" style={{fontWeight:"500"}}>
                                        {item.created_name}
                                      </Typography>
                                      <Typography variant="h6" className="text-warning">
                                        {item.status}
                                      </Typography>
                                    </Box>
                </AccordionSummary>
                <AccordionDetails className="accordionBodyColor">
                  <Box>
                    <Box display="flex" alignItems="center" mt={1}>
                      <Typography ml={1}>
                        Crop Name: {item.crop_name}
                      </Typography>
                      <Typography
                        className="text-gray ml-auto"
                        style={{ marginLeft: "auto" }}
                      >
                        {item.created_at.slice(0, 10)}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" mt={1}>
                      <Typography className="mx-2">
                        Buyer Location : {item.StateName}, {item.DistrictName},{" "}
                        {item.BlockName}, {item.pincode}
                      </Typography>
                    </Box>
                    {/* <Box display="flex" alignItems="center" mt={1}>
                      <Typography ml={1}>
                        Total Price : ₹{item.quantity * item.price}
                      </Typography>
                      <Typography
                        className="text-gray ml-auto"
                        style={{ marginLeft: "auto" }}
                      >
                        Price/Unit : ₹{item.price}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" mt={1}>
                      <Typography className="mx-2">
                        Quantity : {item.quantity} {item.unit_of_measure}
                      </Typography>
                    </Box> */}
                       <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexWrap: { xs: "wrap", sm: "nowrap" },
                          marginBottom: 1,
                        }}
                      >
                        <Typography
                           className="text-gray ml-auto mt-1 mx-1"
                          
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <AccessTimeIcon
                            fontSize="small"
                            sx={{ marginRight: 0.5 }}
                          />
                          Payment : {" "}
                          {item?.delivery_and_payment_detail?.payment_type ||
                            "-"}{" "}
                          {item?.delivery_and_payment_detail?.payment_type ===
                            "D+" &&
                          item?.delivery_and_payment_detail?.payment_timeline
                            ? `(${item.delivery_and_payment_detail.payment_timeline} Days)`
                            : ""}
                        </Typography>
                        <Typography className="text-gray ml-auto"
                       >
                          Est Delivery:{" "}
                          {item.delivery_and_payment_detail.delivery_timeline}{" "}
                          Days
                        </Typography>
                      </Box>
                    <Box display="flex" justifyContent="flex-end" mt={2}>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: "#66BB6A", // Green theme color
                          color: "white",
                          borderRadius: 1,
                          "&:hover": {
                            backgroundColor: "#558B2F", // Darker green on hover
                          },
                        }}
                        onClick={() => handleNegotiationView(index, item)}
                        size="small"
                      >
                        {negotiationView === index
                          ? "Close Negotiation"
                          : "Negotiate"}
                      </Button>
                    </Box>
                    {item?.status ==="Negotiation In progress" ? (
                      <Box display="flex" alignItems="center" mt={2}>
                        <Typography variant="body2" className="text-gray">
                          Expiry Time : {" "}
                        </Typography>
                        <Typography variant="body2" className="text-warning">
                          {item.negotiation_detail.expired_in}
                        </Typography>
                        {item?.negotiation_detail?.is_expired && (
                          <Tooltip title="Increase Timeline">
                            <span
                              className="contract_note cursor-pointer mx-2"
                              onClick={(event) =>
                                handlePopoverOpenTimeline(event, item)
                              }
                            >
                              Increase Timeline &nbsp;<AccessTimeIcon
                                size="small"
                                className="badge-icon"
                              />
                            </span>
                          </Tooltip>
                        )}
                      </Box>
                    ):""}
                  </Box>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Grid>
      )}
      {negotiationView !== null && (
        <Grid item xs={12} md={6}>
          <Box
            p={1}
            border={1}
            borderColor="grey.300"
            boxShadow="0px 4px 10px rgba(0, 0, 0, 0.1)"
            bgcolor="white"
          >
            <div
              style={{
                padding: "10px",
                borderRadius: "8px",
                lineHeight: "1.6",
              }}
            >
              <p style={{ fontSize: "15px", color: "#333", margin: 0 }}>
                Negotiate with{" "}
                <span style={{ color: "#1976d2" }}>
                  {negotiationItem?.created_name}
                </span>
              </p>

              {/* Row 1: Actual Price and Actual Quantity */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "10px 0",
                }}
              >
                <div>
                  <b>Quoted Price :</b>{" "}
                  <span style={{ color: "orange" }}>
                    ₹ {negotiationItem?.price}
                  </span>
                </div>
                <div>
                  <b>Quoted Quantity :</b>{" "}
                  <span style={{ color: "orange" }}>
                    {negotiationItem?.quantity} {BuyersList?.unit_of_measure}
                  </span>{" "}
                </div>
              </div>

              {/* Row 2: Payment Type and Delivery Timeline */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "10px 0",
                }}
              >
                <div>
                  <b>Payment Type :</b>{" "}
                  <span style={{ color: "orange" }}>
                    {negotiationItem?.delivery_and_payment_detail?.payment_type}
                  </span>
                </div>
                <div>
                  <b>Delivery Timeline :</b>{" "}
                  <span style={{ color: "orange" }}>
                    {
                      negotiationItem?.delivery_and_payment_detail
                        ?.delivery_timeline
                    }{" "}
                    Days
                  </span>
                </div>
              </div>

              {/* Payment Timeline (Conditional) */}
              {negotiationItem?.delivery_and_payment_detail?.payment_type ===
                "D+" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    margin: "10px 0",
                  }}
                >
                  <div>
                    <b>Payment Timeline :</b>{" "}
                    <span style={{ color: "orange" }}>
                      {
                        negotiationItem?.delivery_and_payment_detail
                          ?.payment_timeline
                      }{" "}
                      Days
                    </span>
                  </div>
                </div>
              )}
            </div>
            <NegotiateWithSeller
              negotiationItem={negotiationItem}
              user_id={user_id}
              BuyersList={BuyersList}
              UserType="Seller"
              refetch={refetch}
              setNegotiationView={setNegotiationView}
              setInterestedBuyerModal={setInterestedBuyerModal} queryId={user_id} query={negotiationItem} showFields={showFields} setShowFields={setShowFields}
              negotiatioanValues={negotiatioanValues} setNegotiationValue={setNegotiationValue} refetchBuyers={refetchBuyers}
            />
          </Box>
        </Grid>
      )}
      <Popover
        open={Boolean(anchorTimeline)}
        anchorEl={anchorTimeline}
        onClose={handlePopoverCloseTimeline}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ style: { maxWidth: "260px", padding: "16px" } }}
      >
        <IconButton
          size="small"
          onClick={handlePopoverCloseTimeline}
          sx={{ color: "grey.600", float: "right" }}
        >
          <CancelIcon fontSize="small" />
        </IconButton>
        <Typography variant="subtitle1" gutterBottom>
          Modify Timeline
        </Typography>
        <Select
          value={selectedDay}
          onChange={(e) => setSelectedDay(e.target.value)}
          displayEmpty
          fullWidth
          size="small"
          sx={{ mb: 2 }}
        >
          <MenuItem value="" disabled>
            Select Days
          </MenuItem>
          <MenuItem value={1}>1 Day</MenuItem>
          <MenuItem value={2}>2 Days</MenuItem>
          <MenuItem value={3}>3 Days</MenuItem>
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleIncreaseTimeline}
          fullWidth
          size="small"
        >
                    Submit &nbsp; {timelineloader?<Spinner size="sm"/>:""}
                    </Button>
      </Popover>
    </Grid>
  );
}
